import React from "react";
import {
  ISastBackgroundData,
  ISastBackgroundDetailsData,
} from "../../exports/interfaces";

const UndergraduateIntro = (props: {
  sastBackground: ISastBackgroundData[];
  sastBackgroundDetails: ISastBackgroundDetailsData[];
}) => {
  const [activeIndex, setActiveIndex] = React.useState<number>(0);
  const handleClick = (index: number) => {
    setActiveIndex(index);
  };
  return (
    <section>
      <div className="td_height_120 td_height_lg_80" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          {/* <p
            className="td_section_subtitle_up td_fs_18 td_spacing_1 td_mb_10 td_accent_color"
            style={{ textAlign: "unset" }}
          >
            Broad Deep Rigorous
          </p> */}
          <h2 className="td_section_title td_fs_48">
            School of Arts, Sciences & Technology (SAST)
          </h2>
          {/* <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            UNDERGRADUATE PROGRAM
          </p> */}
          <div className="td_height_30 td_height_lg_30" />
        </div>
        {/* <div className="td_fs_18" style={{ textAlign: "justify" }}>
          <p
            dangerouslySetInnerHTML={{
              __html: props?.sastBackground[0]?.description,
            }}
          />
        </div> */}
        <div
          className="td_fs_18 custom-text-p"
          style={{ marginBottom: "30px" }}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: props?.sastBackground[0]?.description,
            }}
          />
          <div className="d-flex justify-content-center">
            <img
              src={`${process.env.REACT_APP_cmsUrl}${props?.sastBackground[0]?.image[0]?.media?.url}`}
              alt="SAST"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            />
          </div>
          <p
            className="mt-2"
            dangerouslySetInnerHTML={{
              __html: props?.sastBackground[0]?.second_description,
            }}
          />
        </div>
        <section>
          <div className="outer_td_post">
            {props.sastBackgroundDetails.map((data, index) => {
              const isActive = activeIndex === index;

              const itemClass = `td_post_item ${isActive ? "active" : ""}`;
              return (
                <div
                  className={itemClass}
                  key={index}
                  onClick={() => handleClick(index)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div
                    className={`td_post custom_td_post td_style_1 td_type_1 gap-0 ${isActive ? "active" : ""}`}
                  >
                    <div
                      className={`td_post_info custom_td_post_info ${isActive ? "active" : ""}`}
                    >
                      {/* LEFT IMAGE */}
                      <div className="post_image">
                        <img
                          src={`${process.env.REACT_APP_cmsUrl}${data?.image[0]?.media?.url}`}
                          alt={`sast-${index}`}
                        />
                      </div>

                      {/* RIGHT CONTENT */}
                      <div className="post_content">
                        <h2 className="td_fs_18 td_medium td_mb_16 overlay-text">
                          {data?.title}
                        </h2>
                        <h2 className="td_fs_20 td_medium td_mb_16 container-text">
                          {data?.title}
                        </h2>

                        <div
                          className={`post-description ${
                            isActive ? "show" : ""
                          }`}
                        >
                          <span
                            className={`td_opacity_7 td_fs_18 sast_description ${
                              isActive ? "show" : ""
                            }`}
                            dangerouslySetInnerHTML={{
                              __html: data?.description,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
        {/* <div
          className="td_fs_18"
          style={{ textAlign: "justify", margin: "30px 0px" }}
        >
          <p className="mb-0">
            Its defining features reflect a coherent curricular design and a
            strong commitment to developing intellectually agile, socially
            responsible, and adaptable graduates. Through a carefully scaffolded
            approach that emphasizes breadth and depth, exploration and
            application, the program fosters analytical rigor, intellectual
            versatility, and a sustained commitment to lifelong learning.
          </p>
        </div> */}
        {/* <div
          className="td_fs_18"
          style={{ textAlign: "justify", marginTop: "30px" }}
        >
          <p className="mb-0">
            This balanced program prepares graduates to think across boundaries,
            solve problems creatively, and contribute to society with
            confidence.
          </p>
        </div> */}
      </div>
      {/* <div className="td_height_120 td_height_lg_80" /> */}
    </section>
  );
};

export default UndergraduateIntro;
